var map = {
	"./": 18305,
	"./App": 9555,
	"./App.js": 9555,
	"./App.test": 60754,
	"./App.test.js": 60754,
	"./assets/fonts/Saira-Bold.ttf": 38055,
	"./assets/fonts/Saira-ExtraBold.ttf": 97131,
	"./assets/fonts/Saira-Medium.ttf": 51679,
	"./assets/fonts/Saira-Regular.ttf": 76980,
	"./assets/images/arrow-round.png": 14335,
	"./assets/images/arrows/arrow-left-modal.png": 24476,
	"./assets/images/arrows/arrow-right-modal.png": 80238,
	"./assets/images/arrows/close.png": 60006,
	"./assets/images/arrows/left-disabled.svg": 17508,
	"./assets/images/arrows/left.svg": 4825,
	"./assets/images/arrows/right-disabled.svg": 81937,
	"./assets/images/arrows/right.svg": 88566,
	"./assets/images/bg-404-mobile.png": 83195,
	"./assets/images/bg-404.png": 25538,
	"./assets/images/desktop/Tpa-bg.png": 37574,
	"./assets/images/desktop/about-us-hero.png": 8938,
	"./assets/images/desktop/about-us-img.png": 85851,
	"./assets/images/desktop/arena/aov.jpg": 46711,
	"./assets/images/desktop/arena/gfp.jpg": 54211,
	"./assets/images/desktop/arena/ml.jpg": 43630,
	"./assets/images/desktop/arena/quake.jpg": 38098,
	"./assets/images/desktop/banner-1.jpg": 13369,
	"./assets/images/desktop/banner-1.png": 61250,
	"./assets/images/desktop/banner-2.jpg": 36950,
	"./assets/images/desktop/banner-2.png": 24424,
	"./assets/images/desktop/banner-3-img-1.png": 32843,
	"./assets/images/desktop/banner-3-img-2.png": 36505,
	"./assets/images/desktop/banner-3-img-3.png": 33630,
	"./assets/images/desktop/banner-3.jpg": 15988,
	"./assets/images/desktop/banner-3.png": 4130,
	"./assets/images/desktop/banner-4-btc.png": 40788,
	"./assets/images/desktop/banner-4-coins.png": 75676,
	"./assets/images/desktop/banner-4-eth.png": 69180,
	"./assets/images/desktop/banner-4-img-1.png": 19315,
	"./assets/images/desktop/banner-4-img-2.png": 52282,
	"./assets/images/desktop/banner-4-usdt.png": 22467,
	"./assets/images/desktop/banner-4.jpg": 6310,
	"./assets/images/desktop/banner-4.png": 64705,
	"./assets/images/desktop/banner-icon.png": 76817,
	"./assets/images/desktop/bg-404.jpg": 69605,
	"./assets/images/desktop/bg-404.png": 75086,
	"./assets/images/desktop/cod/cod.jpg": 18567,
	"./assets/images/desktop/cod/hearthstone.jpg": 26727,
	"./assets/images/desktop/cod/naraka.jpg": 60036,
	"./assets/images/desktop/cod/r6.jpg": 69712,
	"./assets/images/desktop/contact/Group 1107@3x.png": 25771,
	"./assets/images/desktop/contact/Group 1177@3x.png": 60369,
	"./assets/images/desktop/contact/Group 1178@3x.png": 78014,
	"./assets/images/desktop/contact/bg-image.jpg": 88855,
	"./assets/images/desktop/contact/bg-image.png": 60862,
	"./assets/images/desktop/contact/mockup-all.png": 30074,
	"./assets/images/desktop/contact/mockup-all@3x.png": 71987,
	"./assets/images/desktop/contact/skype.png": 45476,
	"./assets/images/desktop/contact/telegram.png": 21063,
	"./assets/images/desktop/csgo/crossfire.jpg": 33271,
	"./assets/images/desktop/csgo/csgo.jpg": 9720,
	"./assets/images/desktop/csgo/hots.jpg": 41905,
	"./assets/images/desktop/csgo/nba.jpg": 30543,
	"./assets/images/desktop/dota/dota.jpg": 68122,
	"./assets/images/desktop/dota/fifa.jpg": 59272,
	"./assets/images/desktop/dota/kog.jpg": 2307,
	"./assets/images/desktop/dota/ow.jpg": 20001,
	"./assets/images/desktop/en/arrow-round.png": 42275,
	"./assets/images/desktop/en/banner-1-heading-sub.png": 94456,
	"./assets/images/desktop/en/banner-1-heading.png": 5543,
	"./assets/images/desktop/en/banner-2-heading-sub.png": 54406,
	"./assets/images/desktop/en/banner-2-heading.png": 12246,
	"./assets/images/desktop/en/banner-2-title.png": 53771,
	"./assets/images/desktop/en/banner-3-heading-sub.png": 4317,
	"./assets/images/desktop/en/banner-3-heading.png": 74867,
	"./assets/images/desktop/en/banner-3-title.png": 2262,
	"./assets/images/desktop/en/banner-4-heading-sub.png": 88753,
	"./assets/images/desktop/en/banner-4-heading.png": 25542,
	"./assets/images/desktop/en/banner-4-title.png": 85642,
	"./assets/images/desktop/en/exclusive-csgodefuse.png": 95362,
	"./assets/images/desktop/en/exclusive-csgoflip.png": 32940,
	"./assets/images/desktop/en/exclusive-dotaAttack.png": 20343,
	"./assets/images/desktop/en/exclusive-dotadice.png": 68211,
	"./assets/images/desktop/en/exclusive-dotatreasure.png": 84298,
	"./assets/images/desktop/en/exclusive-kogdraw.png": 34886,
	"./assets/images/desktop/en/exclusive-lolcouple.png": 30749,
	"./assets/images/desktop/en/exclusive-loldraft.png": 47070,
	"./assets/images/desktop/en/exclusive-loltower.png": 92899,
	"./assets/images/desktop/en/footer/GLI_Certified.png": 47768,
	"./assets/images/desktop/en/footer/Group 1225@3x.png": 51416,
	"./assets/images/desktop/en/imageSvg/arrow-left.svg": 161,
	"./assets/images/desktop/en/imageSvg/arrow-right.svg": 23073,
	"./assets/images/desktop/en/warning modal.png": 74962,
	"./assets/images/desktop/feature-device.png": 22505,
	"./assets/images/desktop/flag-en.png": 55051,
	"./assets/images/desktop/flag-zh.png": 17969,
	"./assets/images/desktop/floating-bg.png": 45781,
	"./assets/images/desktop/g2e-asia.png": 66901,
	"./assets/images/desktop/header-logo.png": 98740,
	"./assets/images/desktop/ice-video-img.png": 3283,
	"./assets/images/desktop/lol/fortnite.jpg": 22829,
	"./assets/images/desktop/lol/lol.jpg": 46189,
	"./assets/images/desktop/lol/pubg.jpg": 75875,
	"./assets/images/desktop/lol/wildrift.jpg": 57002,
	"./assets/images/desktop/lootbox-bg.jpg": 51640,
	"./assets/images/desktop/marquee/betway.png": 97391,
	"./assets/images/desktop/marquee/fun88.png": 6168,
	"./assets/images/desktop/marquee/gamingSoft.png": 98469,
	"./assets/images/desktop/marquee/goldenF.png": 53820,
	"./assets/images/desktop/marquee/hongtu.png": 33726,
	"./assets/images/desktop/marquee/hongtu2.png": 66192,
	"./assets/images/desktop/marquee/idnPlay.png": 14191,
	"./assets/images/desktop/marquee/jbo.png": 17605,
	"./assets/images/desktop/marquee/kok1.png": 46036,
	"./assets/images/desktop/marquee/m88.png": 5905,
	"./assets/images/desktop/marquee/mansion8.png": 74351,
	"./assets/images/desktop/marquee/newBet.png": 56415,
	"./assets/images/desktop/marquee/tcGaming.png": 39592,
	"./assets/images/desktop/marquee/wb.png": 51489,
	"./assets/images/desktop/marquee/wb2.png": 13985,
	"./assets/images/desktop/marquee/world-network.png": 22360,
	"./assets/images/desktop/marquee/yibo.png": 27163,
	"./assets/images/desktop/modal_mobile.png": 41015,
	"./assets/images/desktop/play-btn.png": 8478,
	"./assets/images/desktop/services-1.png": 86007,
	"./assets/images/desktop/services-2.png": 84779,
	"./assets/images/desktop/services-3.png": 88579,
	"./assets/images/desktop/services-4.png": 56474,
	"./assets/images/desktop/services-5.png": 49696,
	"./assets/images/desktop/services-6.png": 87614,
	"./assets/images/desktop/services-7.png": 10987,
	"./assets/images/desktop/services-8.png": 7893,
	"./assets/images/desktop/tf-g2e/1.jpg": 95680,
	"./assets/images/desktop/tf-g2e/10.jpg": 54587,
	"./assets/images/desktop/tf-g2e/11.jpg": 35335,
	"./assets/images/desktop/tf-g2e/12.jpg": 5848,
	"./assets/images/desktop/tf-g2e/2.jpg": 1031,
	"./assets/images/desktop/tf-g2e/3.jpg": 45299,
	"./assets/images/desktop/tf-g2e/4.jpg": 29217,
	"./assets/images/desktop/tf-g2e/5.jpg": 71556,
	"./assets/images/desktop/tf-g2e/6.jpg": 66627,
	"./assets/images/desktop/tf-g2e/7.jpg": 38241,
	"./assets/images/desktop/tf-g2e/8.jpg": 61351,
	"./assets/images/desktop/tf-g2e/9.jpg": 73922,
	"./assets/images/desktop/tf-ice/1.jpg": 59598,
	"./assets/images/desktop/tf-ice/10.jpg": 35806,
	"./assets/images/desktop/tf-ice/2.jpg": 68584,
	"./assets/images/desktop/tf-ice/3.jpg": 53632,
	"./assets/images/desktop/tf-ice/4.jpg": 19162,
	"./assets/images/desktop/tf-ice/5.jpg": 90104,
	"./assets/images/desktop/tf-ice/6.jpg": 11450,
	"./assets/images/desktop/tf-ice/7.jpg": 39424,
	"./assets/images/desktop/tf-ice/8.jpg": 82711,
	"./assets/images/desktop/tf-ice/9.jpg": 96398,
	"./assets/images/desktop/zh/arrows/arrow-left-modal.png": 44743,
	"./assets/images/desktop/zh/arrows/arrow-right-modal.png": 24272,
	"./assets/images/desktop/zh/arrows/close.png": 65617,
	"./assets/images/desktop/zh/arrows/left-disabled.svg": 82778,
	"./assets/images/desktop/zh/arrows/left.svg": 8752,
	"./assets/images/desktop/zh/arrows/right-disabled.svg": 29861,
	"./assets/images/desktop/zh/arrows/right.svg": 93999,
	"./assets/images/desktop/zh/banner-1-heading-sub.png": 91823,
	"./assets/images/desktop/zh/banner-1-heading.png": 7123,
	"./assets/images/desktop/zh/banner-2-heading-sub.png": 88161,
	"./assets/images/desktop/zh/banner-2-heading.png": 42228,
	"./assets/images/desktop/zh/banner-2-title.png": 52845,
	"./assets/images/desktop/zh/banner-3-heading-sub.png": 39309,
	"./assets/images/desktop/zh/banner-3-heading.png": 12348,
	"./assets/images/desktop/zh/banner-3-title.png": 71480,
	"./assets/images/desktop/zh/banner-4-heading-sub.png": 33411,
	"./assets/images/desktop/zh/banner-4-heading.png": 68975,
	"./assets/images/desktop/zh/banner-4-title.png": 93652,
	"./assets/images/desktop/zh/exclusive-csgodefuse.png": 93510,
	"./assets/images/desktop/zh/exclusive-csgoflip.png": 45445,
	"./assets/images/desktop/zh/exclusive-dotaAttack.png": 55510,
	"./assets/images/desktop/zh/exclusive-dotatreasure.png": 45381,
	"./assets/images/desktop/zh/exclusive-kogdraw.png": 23270,
	"./assets/images/desktop/zh/exclusive-lolcouple.png": 41162,
	"./assets/images/desktop/zh/exclusive-loldraft.png": 43886,
	"./assets/images/desktop/zh/exclusive-loltower.png": 88399,
	"./assets/images/desktop/zh/flag-en.png": 27597,
	"./assets/images/desktop/zh/flag-zh.png": 21201,
	"./assets/images/desktop/zh/footer/GLI_Certified.png": 17303,
	"./assets/images/desktop/zh/footer/Group 1225@3x.png": 98259,
	"./assets/images/desktop/zh/imageSvg/arrow-left.svg": 72761,
	"./assets/images/desktop/zh/imageSvg/arrow-right.svg": 17310,
	"./assets/images/desktop/zh/warning modal.png": 23340,
	"./assets/images/en/banner_1.png": 92437,
	"./assets/images/en/banner_2.png": 18423,
	"./assets/images/en/banner_3.png": 25598,
	"./assets/images/en/banner_4.png": 85056,
	"./assets/images/en/contact.png": 25119,
	"./assets/images/en/demo.png": 63236,
	"./assets/images/en/menu.png": 84931,
	"./assets/images/en/modal_mobile.png": 57618,
	"./assets/images/feature-device.png": 84329,
	"./assets/images/feature-icon-1.png": 8081,
	"./assets/images/feature-icon-2.png": 49498,
	"./assets/images/feature-icon-3.png": 53990,
	"./assets/images/feature-icon-4.png": 71070,
	"./assets/images/feature-icon-5.png": 31431,
	"./assets/images/feature-icon-6.png": 71477,
	"./assets/images/mobile/Tpa-bg.png": 55432,
	"./assets/images/mobile/about-us-hero.png": 32989,
	"./assets/images/mobile/about-us-img.png": 40410,
	"./assets/images/mobile/arena/aov.jpg": 58448,
	"./assets/images/mobile/arena/gfp.jpg": 52616,
	"./assets/images/mobile/arena/ml.jpg": 67745,
	"./assets/images/mobile/arena/quake.jpg": 24281,
	"./assets/images/mobile/banner-1.jpg": 69394,
	"./assets/images/mobile/banner-1.png": 94620,
	"./assets/images/mobile/banner-2.jpg": 31031,
	"./assets/images/mobile/banner-2.png": 53934,
	"./assets/images/mobile/banner-3-img-1.png": 79423,
	"./assets/images/mobile/banner-3-img-2.png": 11607,
	"./assets/images/mobile/banner-3-img-3.png": 68642,
	"./assets/images/mobile/banner-3.jpg": 59809,
	"./assets/images/mobile/banner-3.png": 31803,
	"./assets/images/mobile/banner-4-btc.png": 89352,
	"./assets/images/mobile/banner-4-coins.png": 23291,
	"./assets/images/mobile/banner-4-eth.png": 93592,
	"./assets/images/mobile/banner-4-img-1.png": 73016,
	"./assets/images/mobile/banner-4-img-2.png": 29966,
	"./assets/images/mobile/banner-4-usdt.png": 96928,
	"./assets/images/mobile/banner-4.jpg": 80661,
	"./assets/images/mobile/banner-4.png": 1482,
	"./assets/images/mobile/banner-icon.png": 44182,
	"./assets/images/mobile/bg-404.jpg": 21981,
	"./assets/images/mobile/bg-404.png": 78611,
	"./assets/images/mobile/cod/cod.jpg": 11047,
	"./assets/images/mobile/cod/hearthstone.jpg": 56276,
	"./assets/images/mobile/cod/naraka.jpg": 88507,
	"./assets/images/mobile/cod/r6.jpg": 82380,
	"./assets/images/mobile/contact/Group 1107@3x.png": 17414,
	"./assets/images/mobile/contact/Group 1177@3x.png": 79207,
	"./assets/images/mobile/contact/Group 1178@3x.png": 76034,
	"./assets/images/mobile/contact/bg-image.jpg": 29482,
	"./assets/images/mobile/contact/bg-image.png": 31655,
	"./assets/images/mobile/contact/mockup-all.png": 93898,
	"./assets/images/mobile/contact/mockup-all@3x.png": 41902,
	"./assets/images/mobile/contact/skype.png": 50108,
	"./assets/images/mobile/contact/telegram.png": 97461,
	"./assets/images/mobile/csgo/crossfire.jpg": 21854,
	"./assets/images/mobile/csgo/csgo.jpg": 50673,
	"./assets/images/mobile/csgo/hots.jpg": 90358,
	"./assets/images/mobile/csgo/nba.jpg": 34038,
	"./assets/images/mobile/dota/dota.jpg": 94120,
	"./assets/images/mobile/dota/fifa.jpg": 35111,
	"./assets/images/mobile/dota/kog.jpg": 32814,
	"./assets/images/mobile/dota/ow.jpg": 93541,
	"./assets/images/mobile/en/arrow-round.png": 10391,
	"./assets/images/mobile/en/banner-1-heading-sub.png": 17485,
	"./assets/images/mobile/en/banner-1-heading.png": 71482,
	"./assets/images/mobile/en/banner-2-heading-sub.png": 48656,
	"./assets/images/mobile/en/banner-2-heading.png": 30273,
	"./assets/images/mobile/en/banner-2-title.png": 27965,
	"./assets/images/mobile/en/banner-3-heading-sub.png": 17438,
	"./assets/images/mobile/en/banner-3-heading.png": 13266,
	"./assets/images/mobile/en/banner-3-title.png": 45673,
	"./assets/images/mobile/en/banner-4-heading-sub.png": 66557,
	"./assets/images/mobile/en/banner-4-heading.png": 23435,
	"./assets/images/mobile/en/banner-4-title.png": 95178,
	"./assets/images/mobile/en/exclusive-csgodefuse.png": 33936,
	"./assets/images/mobile/en/exclusive-csgoflip.png": 85915,
	"./assets/images/mobile/en/exclusive-dotaAttack.png": 24530,
	"./assets/images/mobile/en/exclusive-dotatreasure.png": 94150,
	"./assets/images/mobile/en/exclusive-kogdraw.png": 58645,
	"./assets/images/mobile/en/exclusive-lolcouple.png": 2254,
	"./assets/images/mobile/en/exclusive-loldraft.png": 24621,
	"./assets/images/mobile/en/exclusive-loltower.png": 1648,
	"./assets/images/mobile/en/footer/GLI_Certified.png": 13995,
	"./assets/images/mobile/en/footer/Group 1225@3x.png": 48601,
	"./assets/images/mobile/en/imageSvg/arrow-left.svg": 53694,
	"./assets/images/mobile/en/imageSvg/arrow-right.svg": 9110,
	"./assets/images/mobile/feature-device.png": 84477,
	"./assets/images/mobile/flag-en.png": 35795,
	"./assets/images/mobile/flag-zh.png": 23023,
	"./assets/images/mobile/floating-bg.png": 87638,
	"./assets/images/mobile/g2e-asia.png": 76549,
	"./assets/images/mobile/header-logo.png": 63049,
	"./assets/images/mobile/ice-video-img.png": 51201,
	"./assets/images/mobile/lol/fortnite.jpg": 95641,
	"./assets/images/mobile/lol/lol.jpg": 93855,
	"./assets/images/mobile/lol/pubg.jpg": 66184,
	"./assets/images/mobile/lol/wildrift.jpg": 89040,
	"./assets/images/mobile/lootbox-bg.jpg": 82381,
	"./assets/images/mobile/marquee/betway.png": 39342,
	"./assets/images/mobile/marquee/fun88.png": 18114,
	"./assets/images/mobile/marquee/gamingSoft.png": 60496,
	"./assets/images/mobile/marquee/goldenF.png": 81160,
	"./assets/images/mobile/marquee/hongtu.png": 57445,
	"./assets/images/mobile/marquee/hongtu2.png": 97257,
	"./assets/images/mobile/marquee/idnPlay.png": 47922,
	"./assets/images/mobile/marquee/jbo.png": 28911,
	"./assets/images/mobile/marquee/kok1.png": 31905,
	"./assets/images/mobile/marquee/m88.png": 97466,
	"./assets/images/mobile/marquee/mansion8.png": 71058,
	"./assets/images/mobile/marquee/newBet.png": 61361,
	"./assets/images/mobile/marquee/tcGaming.png": 38435,
	"./assets/images/mobile/marquee/wb.png": 45290,
	"./assets/images/mobile/marquee/wb2.png": 11154,
	"./assets/images/mobile/marquee/world-network.png": 4669,
	"./assets/images/mobile/marquee/yibo.png": 2800,
	"./assets/images/mobile/modal_mobile.png": 62907,
	"./assets/images/mobile/play-btn.png": 94009,
	"./assets/images/mobile/services-1.png": 24255,
	"./assets/images/mobile/services-2.png": 1688,
	"./assets/images/mobile/services-3.png": 73303,
	"./assets/images/mobile/services-4.png": 75101,
	"./assets/images/mobile/services-5.png": 47914,
	"./assets/images/mobile/services-6.png": 759,
	"./assets/images/mobile/services-7.png": 7563,
	"./assets/images/mobile/services-8.png": 11858,
	"./assets/images/mobile/tf-g2e/1.jpg": 22172,
	"./assets/images/mobile/tf-g2e/10.jpg": 87558,
	"./assets/images/mobile/tf-g2e/11.jpg": 34117,
	"./assets/images/mobile/tf-g2e/12.jpg": 31545,
	"./assets/images/mobile/tf-g2e/2.jpg": 47304,
	"./assets/images/mobile/tf-g2e/3.jpg": 20804,
	"./assets/images/mobile/tf-g2e/4.jpg": 18600,
	"./assets/images/mobile/tf-g2e/5.jpg": 88288,
	"./assets/images/mobile/tf-g2e/6.jpg": 30992,
	"./assets/images/mobile/tf-g2e/7.jpg": 52319,
	"./assets/images/mobile/tf-g2e/8.jpg": 59833,
	"./assets/images/mobile/tf-g2e/9.jpg": 35094,
	"./assets/images/mobile/tf-ice/1.jpg": 43035,
	"./assets/images/mobile/tf-ice/10.jpg": 46738,
	"./assets/images/mobile/tf-ice/2.jpg": 36709,
	"./assets/images/mobile/tf-ice/3.jpg": 49565,
	"./assets/images/mobile/tf-ice/4.jpg": 76119,
	"./assets/images/mobile/tf-ice/5.jpg": 4129,
	"./assets/images/mobile/tf-ice/6.jpg": 77002,
	"./assets/images/mobile/tf-ice/7.jpg": 35480,
	"./assets/images/mobile/tf-ice/8.jpg": 2947,
	"./assets/images/mobile/tf-ice/9.jpg": 23249,
	"./assets/images/mobile/zh/arrows/arrow-left-modal.png": 77806,
	"./assets/images/mobile/zh/arrows/arrow-right-modal.png": 67412,
	"./assets/images/mobile/zh/arrows/close.png": 8690,
	"./assets/images/mobile/zh/arrows/left-disabled.svg": 90809,
	"./assets/images/mobile/zh/arrows/left.svg": 3265,
	"./assets/images/mobile/zh/arrows/right-disabled.svg": 34190,
	"./assets/images/mobile/zh/arrows/right.svg": 48442,
	"./assets/images/mobile/zh/banner-1-heading-sub.png": 12901,
	"./assets/images/mobile/zh/banner-1-heading.png": 6457,
	"./assets/images/mobile/zh/banner-2-heading-sub.png": 61666,
	"./assets/images/mobile/zh/banner-2-heading.png": 75632,
	"./assets/images/mobile/zh/banner-2-title.png": 62588,
	"./assets/images/mobile/zh/banner-3-heading-sub.png": 73333,
	"./assets/images/mobile/zh/banner-3-heading.png": 75156,
	"./assets/images/mobile/zh/banner-3-title.png": 38440,
	"./assets/images/mobile/zh/banner-4-heading-sub.png": 63004,
	"./assets/images/mobile/zh/banner-4-heading.png": 38750,
	"./assets/images/mobile/zh/banner-4-title.png": 57181,
	"./assets/images/mobile/zh/exclusive-csgodefuse.png": 12956,
	"./assets/images/mobile/zh/exclusive-csgoflip.png": 20248,
	"./assets/images/mobile/zh/exclusive-dotaAttack.png": 40664,
	"./assets/images/mobile/zh/exclusive-dotadice.png": 34605,
	"./assets/images/mobile/zh/exclusive-dotatreasure.png": 6368,
	"./assets/images/mobile/zh/exclusive-kogdraw.png": 66626,
	"./assets/images/mobile/zh/exclusive-lolcouple.png": 89934,
	"./assets/images/mobile/zh/exclusive-loldraft.png": 10400,
	"./assets/images/mobile/zh/exclusive-loltower.png": 66502,
	"./assets/images/mobile/zh/flag-en.png": 29664,
	"./assets/images/mobile/zh/flag-zh.png": 92527,
	"./assets/images/mobile/zh/footer/GLI_Certified.png": 63561,
	"./assets/images/mobile/zh/footer/Group 1225@3x.png": 64053,
	"./assets/images/mobile/zh/imageSvg/arrow-left.svg": 35602,
	"./assets/images/mobile/zh/imageSvg/arrow-right.svg": 28080,
	"./assets/images/zh/banner_1.png": 17667,
	"./assets/images/zh/banner_2.png": 50243,
	"./assets/images/zh/banner_3.png": 87840,
	"./assets/images/zh/banner_4.png": 67415,
	"./assets/images/zh/contact.png": 83540,
	"./assets/images/zh/contact/Group 1107@3x.png": 62966,
	"./assets/images/zh/contact/Group 1177@3x.png": 22270,
	"./assets/images/zh/contact/Group 1178@3x.png": 90756,
	"./assets/images/zh/contact/bg-image.jpg": 24338,
	"./assets/images/zh/contact/bg-image.png": 16678,
	"./assets/images/zh/contact/mockup-all.png": 59378,
	"./assets/images/zh/contact/mockup-all@3x.png": 53494,
	"./assets/images/zh/contact/skype.png": 45943,
	"./assets/images/zh/contact/telegram.png": 87528,
	"./assets/images/zh/demo.png": 55362,
	"./assets/images/zh/menu.png": 53989,
	"./assets/images/zh/modal_mobile.png": 33259,
	"./components/demo": 82915,
	"./components/demo/": 82915,
	"./components/demo/index": 82915,
	"./components/demo/index.js": 82915,
	"./components/float": 27549,
	"./components/float.js": 27549,
	"./components/footer": 96281,
	"./components/footer/": 96281,
	"./components/footer/index": 96281,
	"./components/footer/index.js": 96281,
	"./components/header": 17250,
	"./components/header/": 17250,
	"./components/header/index": 17250,
	"./components/header/index.js": 17250,
	"./components/header/lang-switcher": 50593,
	"./components/header/lang-switcher.js": 50593,
	"./components/header/logo": 69228,
	"./components/header/logo.js": 69228,
	"./components/header/mobile": 30075,
	"./components/header/mobile.js": 30075,
	"./components/modal": 73182,
	"./components/modal.js": 73182,
	"./components/sections/aboutUs": 55446,
	"./components/sections/aboutUs/": 55446,
	"./components/sections/aboutUs/index": 55446,
	"./components/sections/aboutUs/index.js": 55446,
	"./components/sections/aboutUs/mobile": 46115,
	"./components/sections/aboutUs/mobile.js": 46115,
	"./components/sections/banner": 56488,
	"./components/sections/banner/": 56488,
	"./components/sections/banner/index": 56488,
	"./components/sections/banner/index.js": 56488,
	"./components/sections/banner/info": 99944,
	"./components/sections/banner/info.js": 99944,
	"./components/sections/banner/mobile": 8368,
	"./components/sections/banner/mobile.js": 8368,
	"./components/sections/contact": 58458,
	"./components/sections/contact.js": 58458,
	"./components/sections/events": 53256,
	"./components/sections/events.js": 53256,
	"./components/sections/exclusive": 64164,
	"./components/sections/exclusive/": 64164,
	"./components/sections/exclusive/index": 64164,
	"./components/sections/exclusive/index.js": 64164,
	"./components/sections/exclusive/info": 2787,
	"./components/sections/exclusive/info.js": 2787,
	"./components/sections/exclusive/mobile": 86641,
	"./components/sections/exclusive/mobile.js": 86641,
	"./components/sections/gallery": 19205,
	"./components/sections/gallery/": 19205,
	"./components/sections/gallery/index": 19205,
	"./components/sections/gallery/index.js": 19205,
	"./components/sections/gallery/info": 65323,
	"./components/sections/gallery/info.js": 65323,
	"./components/sections/gallery/mobile": 99391,
	"./components/sections/gallery/mobile.js": 99391,
	"./components/sections/lootbox": 97042,
	"./components/sections/lootbox/": 97042,
	"./components/sections/lootbox/index": 97042,
	"./components/sections/lootbox/index.js": 97042,
	"./components/sections/lootbox/mobile": 29868,
	"./components/sections/lootbox/mobile.js": 29868,
	"./components/sections/marquee": 18881,
	"./components/sections/marquee.js": 18881,
	"./components/sections/services": 90364,
	"./components/sections/services/": 90364,
	"./components/sections/services/index": 90364,
	"./components/sections/services/index.js": 90364,
	"./components/sections/services/info": 22432,
	"./components/sections/services/info.js": 22432,
	"./components/videos/g2e-assia.mp4": 54849,
	"./components/videos/ice_london.mp4": 29582,
	"./hooks/useDimensionsTracker": 15183,
	"./hooks/useDimensionsTracker.js": 15183,
	"./hooks/useGAEventsTracker": 28119,
	"./hooks/useGAEventsTracker.js": 28119,
	"./hooks/useScrollSpy": 63455,
	"./hooks/useScrollSpy.js": 63455,
	"./i18nextConf": 94558,
	"./i18nextConf.js": 94558,
	"./index": 18305,
	"./index.js": 18305,
	"./layouts": 59425,
	"./layouts/": 59425,
	"./layouts/index": 59425,
	"./layouts/index.js": 59425,
	"./reportWebVitals": 54013,
	"./reportWebVitals.js": 54013,
	"./router": 916,
	"./router/": 916,
	"./router/index": 916,
	"./router/index.js": 916,
	"./setupTests": 79511,
	"./setupTests.js": 79511,
	"./styles/404.scss": 82098,
	"./styles/content.scss": 48046,
	"./styles/demo.scss": 61242,
	"./styles/float.scss": 9227,
	"./styles/fonts.scss": 43754,
	"./styles/footer.scss": 40653,
	"./styles/general.scss": 22943,
	"./styles/header.scss": 40086,
	"./styles/index.scss": 25439,
	"./styles/mobile/about_mobile.scss": 35536,
	"./styles/mobile/banner_mobile.scss": 48757,
	"./styles/mobile/contact_mobile.scss": 65110,
	"./styles/mobile/events_mobile.scss": 72603,
	"./styles/mobile/exclusive_mobile.scss": 65029,
	"./styles/mobile/gallery_mobile.scss": 39257,
	"./styles/mobile/header_mobile.scss": 76957,
	"./styles/mobile/lootbox_mobile.scss": 61033,
	"./styles/mobile/service_mobile.scss": 71869,
	"./styles/modal.scss": 81527,
	"./styles/reset.scss": 43676,
	"./styles/responsive404.scss": 2733,
	"./styles/sections/about-us.scss": 1270,
	"./styles/sections/banner.scss": 60830,
	"./styles/sections/contact.scss": 97018,
	"./styles/sections/events.scss": 44193,
	"./styles/sections/exclusive.scss": 52993,
	"./styles/sections/gallery.scss": 81075,
	"./styles/sections/lootbox.scss": 87333,
	"./styles/sections/marquee.scss": 59753,
	"./styles/sections/services.scss": 70292,
	"./utils/constant": 64879,
	"./utils/constant/": 64879,
	"./utils/constant/index": 64879,
	"./utils/constant/index.js": 64879,
	"./utils/constant/keyframes": 16462,
	"./utils/constant/keyframes.js": 16462,
	"./utils/helpers": 80274,
	"./utils/helpers/": 80274,
	"./utils/helpers/index": 80274,
	"./utils/helpers/index.js": 80274,
	"./views/404": 64161,
	"./views/404.js": 64161,
	"./views/home": 26637,
	"./views/home.js": 26637
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 18116;